// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2IXaD","inputWrap":"CustomTip_inputWrap__btUPK"};